import React from "react";
import { Link, useLocation } from "react-router-dom";
import { MdOutlineFolderCopy } from "react-icons/md";
import { FiUsers } from "react-icons/fi";
import {
  IoSettingsOutline,
  IoStatsChart,
  IoHomeOutline,
  IoGameControllerOutline,
  IoLocationOutline,
} from "react-icons/io5";
import { AiFillProduct } from "react-icons/ai";
import { VscPreview } from "react-icons/vsc";
import { SiSpringCreators } from "react-icons/si";
import { LuMessageSquareMore } from "react-icons/lu";
import { MdOutlinePayments } from "react-icons/md";

import Cookies from "js-cookie";

const Sidebar = () => {
  const location = useLocation();
  const role = Cookies?.get("role");

  return (
    <div className="">
      <div
        className={`fixed top-0 left-0 h-full z-50 bg-[#211849] text-gray-300 transition-transform duration-300 p-3 w-[260px] overflow-y-auto`}
      >
        <div>
          <img src="/assets/images/smallLogo.svg" alt="" className="m-auto" />
        </div>
        <nav className={"flex gap-4 flex-col pt-3"}>
          <Link
            to="/panel/dashboard"
            className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/dashboard"
              ? "bg-[#332B58] text-white"
              : "text-gray-300 bg-transparent hover:bg-[#332B58]"
              }`}
          >
            <IoHomeOutline
              className={`text-lg ${location.pathname === "/panel/dashboard"
                ? "text-white"
                : "text-gray-400"
                }`}
            />
            Dashboard
          </Link>
          <Link
            to="/panel/games"
            className={`py-2 px-4 rounded-xl bg-[#332B58] transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/games"
              ? "bg-[#332B58] text-white"
              : "text-gray-300 bg-transparent hover:bg-[#332B58]"
              }`}
          >
            <IoGameControllerOutline
              className={`text-lg ${location.pathname === "/panel/games"
                ? "text-white"
                : "text-gray-400"
                }`}
            />
            Games
          </Link>
          <Link
            to="/panel/scenario"
            className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/scenario"
              ? "bg-[#332B58] text-white"
              : "text-gray-300 bg-transparent hover:bg-[#332B58]"
              }`}
          >
            <MdOutlineFolderCopy
              className={`text-lg ${location.pathname === "/panel/scenario"
                ? "text-white"
                : "text-gray-400"
                }`}
            />
            Scenarios
          </Link>
          <Link
            to="/panel/users"
            className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-left gap-3 ${location.pathname === "/panel/users"
              ? "bg-[#332B58] text-white"
              : "text-gray-300 bg-transparent hover:bg-[#332B58]"
              }`}
          >
            <FiUsers
              className={`text-lg ${location.pathname === "/panel/users"
                ? "text-white"
                : "text-gray-400"
                }`}
            />
            Dispatch Users
          </Link>
          <Link
            to="/panel/banners"
            className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/banners"
              ? "bg-[#332B58] text-white"
              : "text-gray-300 bg-transparent hover:bg-[#332B58]"
              }`}
          >
            <IoSettingsOutline
              className={`text-lg ${location.pathname === "/panel/banners"
                ? "text-white"
                : "text-gray-400"
                }`}
            />
            Banners
          </Link>
          <Link
            to="/panel/storelocations"
            className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/storelocations"
              ? "bg-[#332B58] text-white"
              : "text-gray-300 bg-transparent hover:bg-[#332B58]"
              }`}
          >
            <IoLocationOutline
              className={`text-lg ${location.pathname === "/panel/storelocations"
                ? "text-white"
                : "text-gray-400"
                }`}
            />
            Store Locations
          </Link>
          <div>
            {role !== "director" && (
              <div className="flex flex-col gap-4 pt-5">
                <img
                  src="/assets/images/everydayHeroesLogo.png"
                  alt=""
                  className="m-auto max-w-[45%]"
                />
                <Link
                  to="/panel/sidekick-users"
                  className={`py-2 px-4  rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/sidekick-users"
                    ? "bg-[#332B58] text-white"
                    : "text-gray-300 bg-transparent hover:bg-[#332B58]"
                    }`}
                >
                  <FiUsers
                    className={`text-lg ${location.pathname === "/panel/sidekick-users"
                      ? "text-white"
                      : "text-gray-400"
                      }`}
                  />
                  Sidekick Users
                </Link>
                <Link
                  to="/panel/sidekick-products"
                  className={`py-2 px-4  rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/sidekick-products"
                    ? "bg-[#332B58] text-white"
                    : "text-gray-300 bg-transparent hover:bg-[#332B58]"
                    }`}
                >
                  <AiFillProduct
                    className={`text-lg ${location.pathname === "/panel/sidekick-products"
                      ? "text-white"
                      : "text-gray-400"
                      }`}
                  />
                  Published Products
                </Link>
                <Link
                  to="/panel/sidekick-statistics"
                  className={`py-2 px-3.5 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/sidekick-statistics"
                    ? "bg-[#332B58] text-white"
                    : "text-gray-300 bg-transparent hover:bg-[#332B58]"
                    }`}
                >
                  <IoStatsChart
                    className={`text-lg ${location.pathname === "/panel/sidekick-statistics"
                      ? "text-white"
                      : "text-gray-400"
                      }`}
                  />
                  Subscription Statistics
                </Link>
                <Link
                  to="/panel/approve-products"
                  className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/approve-products"
                    ? "bg-[#332B58] text-white"
                    : "text-gray-300 bg-transparent hover:bg-[#332B58]"
                    }`}
                >
                  <VscPreview
                    className={`text-lg ${location.pathname === "/panel/approve-products"
                      ? "text-white"
                      : "text-gray-400"
                      }`}
                  />
                  Approve Products
                </Link>
                <Link
                  to="/panel/creators"
                  className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/creators"
                    ? "bg-[#332B58] text-white"
                    : "text-gray-300 bg-transparent hover:bg-[#332B58]"
                    }`}
                >
                  <SiSpringCreators
                    className={`text-lg ${location.pathname === "/panel/approve-products"
                      ? "text-white"
                      : "text-gray-400"
                      }`}
                  />
                  Creators
                </Link>
                <Link
                  to="/panel/manual-creator-payouts"
                  className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/manual-creator-payouts"
                    ? "bg-[#332B58] text-white"
                    : "text-gray-300 bg-transparent hover:bg-[#332B58]"
                    }`}
                >
                  <MdOutlinePayments
                    className={`text-lg ${location.pathname === "/panel/manual-creator-payouts"
                      ? "text-white"
                      : "text-gray-400"
                      }`}
                  />
                  Manual Payouts
                </Link>
                <Link
                  to="/panel/feature-drops"
                  className={`py-2 px-4 rounded-xl transition-colors duration-300 hover:bg-[rgba(29, 136, 218, 0.773)] hover:bg-[#332B58] flex items-center gap-3 ${location.pathname === "/panel/feature-drops" ||
                    location.pathname === "/panel/add-feature-drop" ||
                    location.pathname.includes("/panel/edit-feature-drop/")
                    ? "bg-[#332B58] text-white"
                    : "text-gray-300 bg-transparent hover:bg-[#332B58]"
                    }`}
                >
                  <LuMessageSquareMore
                    className={`text-lg`}
                  />
                  In System Messages
                </Link>
              </div>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
